import React from 'react'

import './table-cell.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    width?: number | string
    computedWidth?: string
    align?: 'left' | 'center' | 'right'
    firstCell?: boolean
    lastCell?: boolean
    strong?: boolean
    minor?: boolean
    error?: boolean
    warning?: boolean
    subRow?: boolean
    noBorder?: boolean
    children?: React.ReactNode
  }
>

const TableCell = ({
  className,
  children,
  computedWidth: width,
  align = 'left',
  firstCell = false,
  lastCell = false,
  strong = false,
  minor = false,
  warning = false,
  error = false,
  subRow = false,
  noBorder = false,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn(
      'TableCell',
      {
        [`align-${align}`]: !!align,
        fixed: !!width && width.includes('px'),
        firstCell,
        lastCell,
        strong,
        minor,
        warning,
        error,
        subRow,
        noBorder,
      },
      className
    )}
    style={{width}}
  >
    <div className="TableCell__content">{children}</div>
  </div>
)

export default TableCell
